const menu = {
  label: '• Macrossegmento Econômico',
  to: '/sol/macrossegmentoeconomico',
  rules: ['SOL-001'],
}

export default menu;